import React from 'react'

const ChevronLeft = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.7068 4.29279C15.8943 4.48031 15.9996 4.73462 15.9996 4.99979C15.9996 5.26495 15.8943 5.51926 15.7068 5.70679L9.41379 11.9998L15.7068 18.2928C15.8889 18.4814 15.9897 18.734 15.9875 18.9962C15.9852 19.2584 15.88 19.5092 15.6946 19.6946C15.5092 19.88 15.2584 19.9852 14.9962 19.9875C14.734 19.9897 14.4814 19.8889 14.2928 19.7068L7.29279 12.7068C7.10532 12.5193 7 12.265 7 11.9998C7 11.7346 7.10532 11.4803 7.29279 11.2928L14.2928 4.29279C14.4803 4.10532 14.7346 4 14.9998 4C15.265 4 15.5193 4.10532 15.7068 4.29279Z" fill="black" />
    </svg>
)

export default ChevronLeft
